


import React, { useState } from "react";
import {
  Box,
  Typography,
  Link,
  Button,
  TextField,
  InputAdornment,
  List,
  ListItem,
  Tooltip,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CreateCohort from "./CreateCohort";
import { useNavigate } from "react-router-dom";
import Plus from "../../../src/assests/images/Plus.svg";
import CohortView from "./CohortView";
import ScheduledAssign from "./ScheduledAssign";
import TotalUserTable from "./TotalUserTable";
import ViewToggle from "./ViewToggle";

// CohortCard component
const AllVendor = ({ onToggle, title }: any) => {
  const navigate = useNavigate();
  const [cortView, setCortView] = useState(null); // Initialize cortView state
  const [searchTerm, setSearchTerm] = useState(""); // Initialize searchTerm state
  const [selectedRows, setSelectedRows] = useState<number[]>([]);
   const [userdatadata, setuserdatadata] = useState("");
  
  return (
    <>
      <Box sx={{ padding: "24px 32px 0", background: "#fff " }}>
        <Link
          href="#"
          sx={{
            textDecoration: "none",
            fontSize: "14px",
            fontWeight: "500",
            color: "rgba(105, 106, 107, 1)",
          }}
        >
          Tasks /
          <Link
            sx={{
              textDecoration: "none",
              fontSize: "14px",
              fontWeight: "600",
              color: "rgba(142, 2, 15, 1)",
            }}
          >
            Assign Task
          </Link>
        </Link>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box>
            <Typography
              variant="h3"
              sx={{
                fontSize: "24px",
                fontWeight: "600",
                color: "#000",
                marginTop: "16px",
              }}
            >
              Assign Task - Know Our Product
            </Typography>
          </Box>
          <Box sx={{ display: "flex", marginRight: "20px" }}>
            <Box sx={{ display: "flex", marginRight: "20px" }}>
              <Box sx={{}}>
                <CreateCohort
                  buttonText="Create Cohort"
                  buttonVariant="outlined"
                  buttonIcon={Plus} cohorttype={""}                />
              </Box>
            </Box>
          </Box>
        </Box>
        <Box sx={{ background: "#F9FBFC", marginTop: "20px" }}>
          <Box sx={{ width: "450px", paddingLeft: "20px" }}>
            <List sx={{ display: "flex" }}>
              <ListItem sx={{ paddingLeft: "0" }}>
                <label style={{ color: "#494A4B" }} htmlFor="name">
                  Points:
                </label>
                <strong id="name">300 Pts</strong>
              </ListItem>
              <ListItem sx={{ paddingLeft: "0" }}>
                <label htmlFor="name">Duration:</label>
                <strong id="name">4 Days</strong>
              </ListItem>
            </List>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginTop: "20px;",
          }}
        >
          <TextField
            required
            placeholder="Search by PMI Entity Code, Outlet Name,Location"
            sx={{
              ".MuiOutlinedInput-root": {
                borderRadius: "12px",
                height: "48px",
                width: "521px",
              },
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            value={searchTerm} // Use the state variable
            onChange={(e) => setSearchTerm(e.target.value)} // Update the state
          />
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ marginTop: "30px" }}>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography
              sx={{
                fontSize: "16px",
                fontWeight: "600",
                marginBottom: "0px",

                marginLeft: "32px",
              }}
            >
              Select folder to assign the task
            </Typography>
            <ViewToggle />
          </Box>
          <Box>
            <TotalUserTable 
            userdatadata={userdatadata}
               selectedRows={selectedRows}
    setSelectedRows={setSelectedRows}
            branddetails={[]} totalCount={0} locationsCount={0} searchTerm={""} Searchlength={""} debouncedSearchTerm={""} page={0} limit={0} totalPages={0} branddetailslength={0} setPage={function (page: number): void {
              throw new Error("Function not implemented.");
            } } value={""} locationsLabel11={[]} outletLabel22={[]} setLocationsLabel={function (value: React.SetStateAction<string[]>): void {
              throw new Error("Function not implemented.");
            } } setOutletLabel={function (value: React.SetStateAction<string[]>): void {
              throw new Error("Function not implemented.");
            } } />
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default AllVendor;